import { createAction } from "@reduxjs/toolkit";
import { ImpersonatedUserData } from "@impersonateUser/models";

export const startImpersonationSession = createAction<ImpersonatedUserData>("impersonation/startImpersonationSession");

export const stopImpersonationSession = createAction("impersonation/stopImpersonationSession");
